module.exports = __webpack_public_path__ + "img/dk_low.2e5dc064.png";